export default __webpack_public_path__ + "static/media/customer2.f664c112.svg";